import { SYMBOLS } from '../../../constants/gameConfig';
import type { SymbolKey } from '../../../types/game';

export const getRandomSymbol = (): SymbolKey => {
    const rand = Math.random();
    let cumulative = 0;

    for (const [symbol, data] of Object.entries(SYMBOLS)) {
        cumulative += data.frequency;
        if (rand <= cumulative) return symbol as SymbolKey;
    }

    return '🍒';
};

export const calculateWin = (slots: string[]): number => {
    // All same symbols
    if (slots.every(slot => slot === slots[0])) {
        const value = SYMBOLS[slots[0] as SymbolKey].value;
        return value * 3;
    }

    // Two matching symbols
    for (let i = 0; i < slots.length - 1; i++) {
        for (let j = i + 1; j < slots.length; j++) {
            if (slots[i] === slots[j]) {
                const value = SYMBOLS[slots[i] as SymbolKey].value;
                return value;
            }
        }
    }

    return 0;
}; 